import type {
  CommandRequest,
  CommandResponse,
  CommandsResponse,
  StatusResponse,
} from "@minecraft-dashboard/shared";

export async function fetchStatus(apiBase: string, signal?: AbortSignal): Promise<StatusResponse> {
  const init: RequestInit = {
    headers: { accept: "application/json" },
  };
  if (signal) init.signal = signal;
  const response = await fetch(`${apiBase}/api/status`, init);
  return readJson<StatusResponse>(response);
}

export async function fetchCommands(apiBase: string, signal?: AbortSignal): Promise<CommandsResponse> {
  const init: RequestInit = {
    headers: { accept: "application/json" },
  };
  if (signal) init.signal = signal;
  const response = await fetch(`${apiBase}/api/commands`, init);
  return readJson<CommandsResponse>(response);
}

export async function postCommand(apiBase: string, body: CommandRequest): Promise<CommandResponse> {
  const response = await fetch(`${apiBase}/api/commands`, {
    method: "POST",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return readJson<CommandResponse>(response);
}

async function readJson<T>(response: Response): Promise<T> {
  const payload = (await response.json().catch(() => null)) as T | null;
  if (!response.ok) {
    const message =
      payload && typeof payload === "object" && "error" in payload
        ? String((payload as { error?: unknown }).error)
        : response.statusText;
    throw new Error(message);
  }
  if (!payload) throw new Error("Empty response");
  return payload;
}
